<template>
    <div>
        <!--탑메뉴-->
        <topbar-comp></topbar-comp>
        <left-bar-comp>
            <sports-left-bar-comp></sports-left-bar-comp>
        </left-bar-comp>

        <div class="content_section">
            <div class="content">
                <sub-title>Deposit</sub-title>

                <div class="main_panel">

                    <apply-buttons-comp></apply-buttons-comp>

                    <div class="re_info">
                        <span style="font-size: 18px">How to deposit ( 3 steps only )</span>
                        <span>
                                * Click Account inquiry at the bottom
                            </span>
                        <span>
                                    * Please deposit into the account you received.
                            </span>
                        <span>
                               * After depositing, select the bonus type and click Apply Game money is charged within 1 minute.
                            </span>

                       </div>


                    <div class="re_cont" style="margin-top: 5px">
                        <div class="c1">
                            Deposit name
                        </div>
                        <div class="c2"
                             style="display: flex;justify-content: flex-start;align-items: center;flex-direction: row">
                            <span>{{$store.state.userInfo.beneficiary}}</span>
                            <button class="askacno" @click="questioAcNo"><i class="fa fa-question-circle"></i>account inquiry
                            </button>
                        </div>
                    </div>
                    <div class="re_cont">
                        <div class="c1">
                            Amount
                        </div>
                        <div class="c2" style="">
                            <div style="display: flex;justify-content: flex-start;align-items: center;padding: 5px 0">
                                <input type="text" v-model="applyCash.amount" class="re_input" placeholder="amount"
                                       style="">
                                <button type="button" class="btn-re" @click="changeMoney(0)"
                                        style="width: 130px;margin-left: 6px">Reset
                                </button>
                            </div>
                            <div style="display: flex; justify-content: flex-start;width: 100%;padding: 3px 0;flex-wrap: wrap">
                                <button type="button" class="btn-re" @click="changeMoney(10000)">
                                    10,000
                                </button>
                                <button type="button" class="btn-re" @click="changeMoney(30000)">
                                    30,000
                                </button>
                                <button type="button" class="btn-re" @click="changeMoney(50000)">
                                    50,000
                                </button>
                                <button type="button" class="btn-re" @click="changeMoney(100000)">
                                    100,000
                                </button>
                                <button type="button" class="btn-re" @click="changeMoney(500000)">
                                    500,000
                                </button>
                                <button type="button" class="btn-re" @click="changeMoney(1000000)">
                                    1,000,000
                                </button>

                            </div>
                        </div>
                    </div>

                    <div class="re_cont">
                        <div class="c1">
                            Bonus Type
                        </div>
                        <div class="c2bonus" style="font-weight: normal;">
                            <div class="bonuspanel">
                                <div style="display: flex;justify-content: flex-start;align-items: center;padding: 5px 0">
                                    <input type="radio" name="bonusin" id="bonusin1"
                                           :value="sportsConst.APPLY_BONUS_YES1"
                                           v-model="applyCash.bonusin">
                                    <span style="margin-left: 5px">
                                                            <label for="bonusin1"
                                                                   style="color: #fff60d"> Sports {{b1}}</label>
                                                        </span>

                                </div>
                                <!--                                <div style="padding-left: 16px;color: deepskyblue;">-->
                                <!--                                    (스포츠,미니게임 이용가능)-->
                                <!--                                </div>-->
                            </div>
<!--                            <div class="bonuspanel">-->
<!--                                <div style="display: flex;justify-content: flex-start;align-items: center;padding: 5px 0">-->
<!--                                    <input type="radio" name="bonusin" id="bonusin2"-->
<!--                                           :value="sportsConst.APPLY_BONUS_YES2"-->
<!--                                           v-model="applyCash.bonusin">-->
<!--                                    <span style="margin-left: 5px">-->
<!--                                                            <label for="bonusin2"-->
<!--                                                                   style="color: skyblue">MiniGame {{b2}}</label>-->
<!--                                                        </span>-->
<!--                                </div>-->
<!--                                &lt;!&ndash;                                <div style="padding-left: 16px;color: #fd7879;">&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    (카지노,슬롯 이용)&ndash;&gt;-->
<!--                                &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
                            <div class="bonuspanel">
                                <div style="display: flex;justify-content: flex-start;align-items: center;padding: 5px 0">
                                    <input type="radio" name="bonusin" id="bonusin3"
                                           :value="sportsConst.APPLY_BONUS_YES3"
                                           v-model="applyCash.bonusin">
                                    <span style="margin-left: 5px">
                                                            <label for="bonusin3"
                                                                   style="color: gainsboro">Casino&Slot  {{b3}}</label>
                                                        </span>
                                </div>
                                <!--                                <div style="padding-left: 16px;color: #fd7879;">-->
                                <!--                                    (카지노,슬롯 이용)-->
                                <!--                                </div>-->
                            </div>
                            <div class="bonuspanel">
                                <div style="display: flex;justify-content: flex-start;align-items: center;padding: 5px 0">
                                    <input type="radio" name="bonusin" id="bonusin4"
                                           :value="sportsConst.APPLY_BONUS_NOT"
                                           v-model="applyCash.bonusin">
                                    <span style="margin-left: 5px;"><label for="bonusin4"
                                                                           style="color: red"> No Bonus {{b4}}</label></span>
                                </div>
                                <div style="padding-left: 16px;color: #fd7879;">
                                    <!-- 포인트를 받지않으며, 기본롤링 100% 이용-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--                    <div style="width: 100%;text-align: center;line-height: 40px;font-weight: bold;color: yellow">
                                            샘플서버입니다. 절대 <span style="color: #ff4d4d;font-size: 19px">`입금`</span> 하지마세요!!!
                                        </div>-->
                    <div class="rec_buttons" style="">


                        <button class="b1" @click="recharge(0)"><i class="fa fa-plus-square"></i> CASH IN
                        </button>
                        <!--                        <button class="b1" @click="recharge(1)">코인충전신청-->
                        <!--                        </button>-->

                    </div>
                </div>
                <div class="re_history">
                    <table class="utable" cellpadding="0" cellspacing="0" border="0">
                        <colgroup>
                            <col width="27%">
                            <col width="27%">
                            <col width="27%">
                            <col width="15%">
                        </colgroup>
                        <thead>
                        <tr>
                            <th>Day</th>
                            <th>Amount</th>
                            <th @click="refreshData()" style="cursor: pointer">status <i class="fa fa-refresh"
                                                                                     aria-hidden="true"></i>
                            </th>
                            <th>-</th>
                        </tr>
                        <tr v-for="(item,indx) in rechargeList" :key="indx">
                            <td>{{item.createTime|datef('MM/DD HH:mm')}}</td>
                            <td>{{item.amount|comma}}</td>
                            <td>
                                <span v-if="item.status === sportsConst.APPLY_STATUS_WAITING">unidentified</span>
                                <span v-if="item.status === sportsConst.APPLY_STATUS_CHECKING">checking</span>
                                <span v-if="item.status === sportsConst.APPLY_STATUS_COMPLITE"><i class="fa fa-check"
                                                                                                  aria-hidden="true"></i></span>
                                <span v-if="item.status === sportsConst.APPLY_STATUS_CANCEL"
                                      style="color: red">fail</span>
                            </td>
                            <td>
                  <span
                          style="display: inline-block;width: 60px; height: 20px; line-height: 20px;text-align: center;cursor: pointer"
                          v-if="item.status !== sportsConst.APPLY_STATUS_WAITING && item.status
                        !== sportsConst.APPLY_STATUS_CHECKING" @click="deleteById(item.id)">
                     <i class="fa fa-close"></i> delete
                  </span>

                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <!-- right 메뉴 -->
        <right-bar-comp>
            <!--내정보-->
            <user-info-comp slot="userinfo"></user-info-comp>
            <right-buttons-comp slot="btns"></right-buttons-comp>
            <!--배팅카트-->
            <sports-bet-cart-comp slot="betcart"></sports-bet-cart-comp>
            <right-bar-banner-comp slot="banner"></right-bar-banner-comp>
        </right-bar-comp>

        <foot-comp></foot-comp>

    </div>

</template>

<script>
    import SubTitle from "../../components/SubTitle";
    import RightBarComp from "../../components/RightBarComp";
    import {
        deleteApply,
        getApplyCashList,
        getM7OutSideLoginUrl, getTodayRechargeStatus,
        rechargeCash,
        saveQuestion
    } from "../../network/userRequest";
    import sportsConst from "../../common/sportsConst";
    import LeftBarComp from "../../components/LeftBarComp";
    import LeisureLeftComp from "../../components/leisuregame/LeisureLeftComp";
    import FootComp from "../../components/FootComp";
    import TopbarComp from "../../components/TopbarComp";
    import RightBarBannerComp from "../../components/RightBarBannerComp";
    import {addMemberCasinoCash, getAccountBalance} from "../../network/casinoRequest";
    import {
        RECEIVE_HIDE_LOADING,
        RECEIVE_SHOW_LOADING,
        RECEIVE_SPORTS_CART_ITEM_DEL_ALL
    } from "../../store/mutation-types";
    import SportsLeftBarComp from "../../components/sports/SportsLeftBarComp";
    import {postionMixin} from "../../common/mixin";
    import UserInfoComp from "../../components/UserInfoComp";
    import RightButtonsComp from "../../components/RightButtonsComp";
    import SportsBetCartComp from "../../components/sports/SportsBetCartComp";
    import ApplyButtonsComp from "../../components/ApplyButtonsComp";

    export default {
        name: "Recharge",
        mixins: [postionMixin],
        components: {
            ApplyButtonsComp,
            SportsBetCartComp,
            RightButtonsComp,
            UserInfoComp,
            SportsLeftBarComp,
            RightBarBannerComp, TopbarComp, FootComp, LeisureLeftComp, LeftBarComp, RightBarComp, SubTitle
        },
        data() {
            return {
                sportsConst,
                applyCash: {
                    amount: 0,
                    bonusin: sportsConst.APPLY_BONUS_YES1,
                    consiterecharge: 0,
                },
                search: {applyType: sportsConst.APPLY_TYPE_RECHARGE},
                rechargeList: [],
                isSampleSite: false,
                casinocash: 0,
                position: "입금",
                b1: null,
                b2: null,
                b3: null,
                b4: null,
                todaystatus: 0,
            }
        },
        methods: {
            goCoinSite() {
                this.$store.commit(RECEIVE_SHOW_LOADING)
                getM7OutSideLoginUrl().then(res => {
                    if (res.data.success) {
                        console.log(res)
                        window.open(res.data.data, '_blank')
                    }
                    this.$store.commit(RECEIVE_HIDE_LOADING)
                })

            },
            goPaySite() {
                window.open('https://point1004.com/b2b_order?g=d788db9b-951d-4f2d-88c7-69cc9c5bac95', '_blank')
            },
            changeMoney(cash) {
                if (cash === 0) {
                    this.applyCash.amount = 0;
                } else {
                    this.applyCash.amount += cash;
                }
            },
            changeCasinoMoney(cash) {
                if (cash === 0) {
                    this.casinocash = 0;
                } else {
                    this.casinocash += parseInt(cash);
                }
            },
            gotocoinsite() {
                window.open(sportsConst.APPLY_COINSITE_URL, '_blank')
            },
            recharge(consiterecharge) {
                this.applyCash.consiterecharge = consiterecharge;
                if (this.applyCash.bonusin === -1) {
                    this.$swal({
                        //title: '보너스 동의를 선택하세요',
                        title: 'Select Bonus Agreement',
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true
                    })
                    return false
                }

                this.$swal({
                   // title: this.applyCash.amount + '원 충전신청 하시겠습니까?',
                    title: 'Would you like to apply for '+this.applyCash.amount + 'won recharge?',
                    type: 'question',
                    confirmButtonText: ' Yes ',
                    cancelButtonText: ' Not '
                }).then((res) => {
                    this.betInfo = {selectedVals: []}
                    if (res.value) {
                        this.$store.commit(RECEIVE_SHOW_LOADING)
                        rechargeCash(this.applyCash).then(res => {
                            if (res.data.success) {
                                this.$swal({
                                    title: 'Success',
                                    type: 'success',
                                    showCancelButton: false,
                                    showConfirmButton: true
                                })
                                this.applyCash.bonusin = 1
                                this.applyCash.amount = 0
                                this.applyCash.consiterecharge = 0;
                                this.initRechargeList()
                            } else {
                                this.$swal({
                                    title: res.data.msg,
                                    type: 'error',
                                    showCancelButton: false,
                                    showConfirmButton: true
                                })
                            }
                            this.$store.commit(RECEIVE_HIDE_LOADING)
                        })
                    }
                })
            },
            change2casinocash() {
                if (this.casinocash > this.$store.state.userInfo.cash) {
                    this.$swal({
                        title: '보유금액 ' + this.$store.state.userInfo.cash + '원을 초과하였습니다',
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true
                    })
                    return false;
                }
                this.$store.commit(RECEIVE_SHOW_LOADING)
                addMemberCasinoCash(this.casinocash).then(res => {
                    this.$store.commit(RECEIVE_HIDE_LOADING)
                    if (res.data.success) {
                        this.$swal({
                            title: '전환성공',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        this.casinocash = 0;
                        this.$store.dispatch('actionUserInfo')
                        setTimeout(() => {
                            this.getCasinoBalance();
                        }, 1300)

                    } else {
                        this.$swal({
                            title: '전환실패, ' + res.data.msg,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                    }

                })
            },
            initRechargeList() {
                this.$store.commit(RECEIVE_SHOW_LOADING)
                getApplyCashList(this.search).then(res => {
                    if (res.data.success) {
                        this.rechargeList = res.data.data
                    }
                    this.$store.commit(RECEIVE_HIDE_LOADING)
                })
            },
            refreshData() {
                this.initRechargeList()
                this.$bus.$emit('applyRequestSuccess')
            },
            deleteById(id) {
                this.$swal({
                    //title: '삭제하시겠습니까?',
                    title: 'Are you sure you want to delete',
                    type: 'question',
                    confirmButtonText: ' Yes ',
                    cancelButtonText: ' Not '
                }).then((res) => {
                    if (res.value) {
                        deleteApply(id).then(res => {
                            if (res.data.success) {
                                this.initRechargeList()
                            } else {
                                this.$swal({
                                    title: res.data.msg,
                                    type: 'error',
                                    showCancelButton: false,
                                    showConfirmButton: true
                                })
                            }
                        })
                    }
                })
            },
            getCasinoBalance() {
                getAccountBalance().then(res => {
                    this.$set(this.$store.state.userInfo, 'casinocash', res.data.data)
                })
            },
            questioAcNo() {
                this.$store.commit(RECEIVE_SHOW_LOADING)
                //let content = '계좌번호 문의합니다'
                let content = 'I would like to inquire about the account number.'
                saveQuestion({'content': content, 'type': sportsConst.CUSTOMER_TYPE_BANK_CARD}).then(res => {
                    this.$store.commit(RECEIVE_HIDE_LOADING)
                    if (res.data.success) {
                        this.content = ''
                        this.$swal({
                            //title: '계좌번호 문의글 작성이 완료되였습니다',
                            title: 'The account number inquiry has been completed.',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        this.$router.push('/customer_center')

                    } else {
                        this.$swal({
                            title: res.data.msg,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                    }
                })
            },
            getTodayRechargeStatus() {
                getTodayRechargeStatus().then(res => {
                    this.todaystatus = res.data.data
                    try {
                        if (this.todaystatus == sportsConst.RECHARGE_FIRSTBONUS) {
                            let b = this.$store.state.userInfo.rank.rechargebonus1.split(",")
                            this.b1 = '(First ' + b[0] + '%)'
                            this.b2 = '(First ' + b[1] + '%)'
                            this.b3 = '(First ' + b[2] + '%)'
                            this.b4 = '(First 0%)'
                        }
                        if (this.todaystatus == sportsConst.RECHARGE_DAYBONUS) {
                            let b = this.$store.state.userInfo.rank.rechargebonus2.split(",")
                            this.b1 = '(Day ' + b[0] + '%)'
                            this.b2 = '(Day ' + b[1] + '%)'
                            this.b3 = '(Day ' + b[2] + '%)'
                            this.b4 = '(Day 0%)'
                        }
                        if (this.todaystatus == sportsConst.RECHARGE_NOBONUS) {
                            this.applyCash.bonusin = sportsConst.APPLY_BONUS_NOT
                        }
                    } catch (e) {

                    }

                })
            },
        },
        created() {
            this.initRechargeList()
            this.getTodayRechargeStatus()
        },
        mounted() {

        },
        watch: {
            "applyCash.bonusin": {
                handler(newVal) {
                },
                immediate: true,
                deep: false
            },
        }
    }
</script>

<style scoped>
    @import url("../../assets/css/base.css");
    @import url("../../assets/css/common.css");
    @import url("../../assets/css/style.css");
    @import url("../../assets/css/media.css");
    @import url("../../assets/css/sports.css");
    @import url("../../assets/css/reex.css");
</style>